module.exports = __webpack_public_path__ + "static/media/image-upload-text.8207d5bc.svg";